// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2DvN1","title":"AfterBackImages_title__2rsPY","images":"AfterBackImages_images__36YE9"};